module.exports = __webpack_public_path__ + "static/img/crinfrid.aed3e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/crinfrid.png
// module id = WD6M
// module chunks = 0